export default __webpack_public_path__ + "static/media/eye-icon.39a0f5f7.svg";